import PortalIdParser from 'PortalIdParser';
import { useMemo } from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../buildStore';
import { getKnowledgeBaseUrl } from '../../selectors/widgetDataSelectors/getKnowledgeBaseUrl';
import hashCode from '../../utils/hashCode';
import { useKBArticle } from '../kbArticleSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const ArticleWrapper = styled.div.withConfig({
  displayName: "KBArticle__ArticleWrapper",
  componentId: "rytgbb-0"
})(["width:100%;height:100%;overflow-y:scroll;"]);
function KBArticle() {
  const kbArticle = useKBArticle();
  const {
    hubSpotContentId,
    hubSpotContentTextFragment
  } = kbArticle;
  const portalId = PortalIdParser.get();
  // anchorName is used for caching purposes even if article isn't from a citation
  const anchorName = hubSpotContentTextFragment ? `aicitation-${hashCode(hubSpotContentTextFragment)}` : `${portalId}${hubSpotContentId}`;
  const encodedOrigin = encodeURIComponent(window.location.origin);
  const knowledgeBaseUrl = useAppSelector(getKnowledgeBaseUrl);
  const onDomainUrl = useMemo(() => {
    const url = new URL(knowledgeBaseUrl);
    url.pathname = '_hcms/customer-agent-embed';
    url.searchParams.set('hubSpotContentType', 'KB_ARTICLE');
    url.searchParams.set('portalId', portalId.toString());
    url.searchParams.set('hubSpotContentId', hubSpotContentId);
    if (hubSpotContentTextFragment) {
      url.searchParams.set('contentTextFragment', hubSpotContentTextFragment);
    }
    url.searchParams.set('includeScript', 'true');
    url.searchParams.set('origin', encodedOrigin);
    url.searchParams.set('anchorName', anchorName);
    return url;
  }, [knowledgeBaseUrl, portalId, hubSpotContentId, hubSpotContentTextFragment, encodedOrigin, anchorName]);
  return /*#__PURE__*/_jsx(ArticleWrapper, {
    children: /*#__PURE__*/_jsx("iframe", {
      src: onDomainUrl.toString(),
      style: {
        width: '100%',
        height: '100%',
        border: 'none'
      },
      id: 'kb-article-iframe'
    })
  });
}
KBArticle.displayName = 'KBArticle';
export default KBArticle;